import { render, staticRenderFns } from "./itemDecorateInfo.vue?vue&type=template&id=a425bb8c"
import script from "./itemDecorateInfo.vue?vue&type=script&lang=js"
export * from "./itemDecorateInfo.vue?vue&type=script&lang=js"
import style0 from "./itemDecorateInfo.vue?vue&type=style&index=0&id=a425bb8c&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports